import(/* webpackMode: "eager", webpackExports: ["WikiShell"] */ "/workspace/dotheforgejo/oxpa-pro/src/app/(portal)/_wiki_components/wiki-shell.tsx");
